import { useContext } from 'react';
import useSWR from 'swr';
import { configurationContext } from '../contexts';
import { getUrl } from '../utils';
async function fetchPersonalMenu(baseUrl, url, options) {
  var _data$Items;
  var data = await getUrl(baseUrl, url, options);
  return {
    user: {
      FirstName: data.CustomerFirstName,
      LastName: data.CustomerLastName,
      UserType: data.UserType,
      UserHash: data.UserHash
    },
    items: (_data$Items = data.Items) !== null && _data$Items !== void 0 ? _data$Items : []
  };
}
function buildUrl(_ref) {
  var isDev = _ref.isDev,
    customerId = _ref.customerId,
    rootLevelOnly = _ref.rootLevelOnly,
    orderType = _ref.orderType,
    userHash = _ref.userHash;
  var delimiter = isDev ? '/' : '?';
  var orderTypeQuery = orderType ? "&orderType=".concat(orderType) : '';
  var userHashQuery = userHash ? "&userHash=".concat(userHash) : '';
  return "/customers/".concat(customerId, "/menu").concat(delimiter, "rootLevelOnly=").concat(rootLevelOnly).concat(orderTypeQuery).concat(userHashQuery);
}
export function usePersonalMenuRootQuery(canFetch) {
  var _useContext = useContext(configurationContext),
    isDev = _useContext.isDev,
    globalApiUrl = _useContext.globalApiUrl,
    token = _useContext.token,
    tenant = _useContext.tenant,
    lang = _useContext.lang,
    customerId = _useContext.customerId,
    personalMenuInitialData = _useContext.personalMenuInitialData;
  return useSWR(canFetch ? buildUrl({
    isDev: isDev,
    customerId: customerId,
    rootLevelOnly: true,
    orderType: personalMenuInitialData === null || personalMenuInitialData === void 0 ? void 0 : personalMenuInitialData.OrderType
  }) : null, async function (url) {
    return fetchPersonalMenu(globalApiUrl, url, {
      token: token,
      tenant: tenant,
      lang: lang,
      isDev: isDev
    });
  });
}
export function usePersonalMenuSubitemsQuery(canFetch, userHash) {
  var _useContext2 = useContext(configurationContext),
    isDev = _useContext2.isDev,
    globalApiUrl = _useContext2.globalApiUrl,
    token = _useContext2.token,
    tenant = _useContext2.tenant,
    lang = _useContext2.lang,
    customerId = _useContext2.customerId,
    personalMenuInitialData = _useContext2.personalMenuInitialData;
  return useSWR(canFetch ? buildUrl({
    isDev: isDev,
    customerId: customerId,
    rootLevelOnly: false,
    orderType: personalMenuInitialData === null || personalMenuInitialData === void 0 ? void 0 : personalMenuInitialData.OrderType,
    userHash: userHash
  }) : null, async function (url) {
    return fetchPersonalMenu(globalApiUrl, url, {
      token: token,
      tenant: tenant,
      lang: lang,
      isDev: isDev
    });
  });
}